import React, { Component } from 'react';
import { Field, FieldArray, reduxForm } from 'redux-form';
import  axios from 'axios';
import validate from './Validations/submitValidationsItemsBuyForm';
import renderField from './RenderField';
import Section from './Section.js'
import {FormattedHTMLMessage} from 'react-intl';
import TopScrolleable from './TopScrolleable.js';
import CustomSpinner from './CustomSpinner';
import Whatsapp from './WhatsappButton.js';
import SaveStepButton from './SaveStepButton';
import withAuthControl from '../auth/Auth.js';
import AttributeOptions from './AttributeOptions.js';

require(`../assets/${process.env.PAGE}/css/components/ItemsBuyForm.css`);

class ItemsBuyForm extends Component {
  constructor(props){
		super(props);
		this.state = {
			factoBusinessAssociation: null,
      destination_credit: null,
	  }
  }

  componentDidMount() {
    const ROOT_URL = process.env.API_URL;
    const config = {
        headers:
            {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + sessionStorage.getItem('jwtToken')
            }
    };

    axios.get(`${ROOT_URL}/leads/details`, config).then((response)=> {
        this.setState({
          factoBusinessAssociation: response.data.facto_business_association,
        });
    });
    axios.get(`${ROOT_URL}/steps/param?param=destination_credit`, config).then((response)=> {
      this.setState({
        destination_credit: response.data.destination_credit,
        });
  });
  }
  renderitemsBuy = ({ fields, meta: { touched, error, submitFailed } }) => (
    <div>
      <div className="text-center">
          <button
          className="btn pd-simple-button save-step-button btn-add-member"
          onClick={(e) => {
            e.preventDefault();
            fields.push({})
          }}>
          <img className="save-step-icon" src={require(`../assets/${process.env.PAGE}/img/add_items_buy.png`)}/>
          <br></br>Agregar Item
          </button>
      </div>
      <div style={{height:'20px'}}></div>
        {(touched || submitFailed) && error && <CustomAlert bsStyle="danger" message={error}/>}
      <div className='pvc-form'>
        {fields.map((items_buy, index) => (
          <div key={index} >
                <div className="delete-member-btn" onClick={() => index !== 0 ? fields.remove(index):''}>x</div>
                <h4>{index + 1}° Item</h4>
                <Field className="form-control" name={`${items_buy}.items_buy_detail`} autoComplete="off" component={renderField} type="text" label="Detalle" />
                <Field className="form-control" name={`${items_buy}.items_buy_amout`} autoComplete="off" component={renderField} type="currency" label="Monto total" />
          <div style={{height:'10px'}}></div>
          </div>
        ))}
      </div>
    </div>
  );

  renderitemsBuyWithFinanced = ({ fields, meta: { touched, error, submitFailed } }) => (
    <div>
      <div className="text-center">
          <button
          className="btn pd-simple-button save-step-button btn-add-member"
          onClick={(e) => {
            e.preventDefault();
            fields.push({})
          }}>
          <img className="save-step-icon" src={require(`../assets/${process.env.PAGE}/img/add_items_buy.png`)}/>
          <br></br>Agregar Item
          </button>
      </div>
      <div style={{height:'20px'}}></div>
        {(touched || submitFailed) && error && <CustomAlert bsStyle="danger" message={error}/>}
      <div className='pvc-form'>
        {fields.map((items_buy, index) => (
          <div key={index} >
                <div className="delete-member-btn" onClick={() => index !== 0 ? fields.remove(index):''}>x</div>
                <h4>{index + 1}° Item</h4>
                <Field className="form-control" name={`${items_buy}.items_buy_detail`} autoComplete="off" component={renderField} type="text" label="Detalle" />
                <Field className="form-control" name={`${items_buy}.items_buy_amout`} autoComplete="off" component={renderField} type="currency" label="Monto total" />
                <AttributeOptions name={`${items_buy}.items_buy_has_financed`} defaultValue="¿Lo financiás con este crédito?"  attributeName='items_buy_has_financed' attributeOptions={[{id:0 , name:'Si'}, {id:1 , name:'No'}]}/>
          <div style={{height:'10px'}}></div>
          </div>
        ))}
      </div>
    </div>
  );

  render() {
    const { handleSubmit, submitting } = this.props;
    const { factoBusinessAssociation, destination_credit } = this.state;

    let title =  factoBusinessAssociation ?
      (<FormattedHTMLMessage id="app.step_items_buy_ss" description="itemsBuy info"/>) :
      (<FormattedHTMLMessage id="app.step_items_buy_os" description="itemsBuy info"/>);

    return (
      <Section className="intro_form">
        <div className="row">
          <div className="pd-content-left col-md-5 col-lg-5 text-center">
              <img alt="Logo" className="center-block intro_logo" src={require(`../assets/${process.env.PAGE}/img/logo-h-blanco.png`)}/>
              {factoBusinessAssociation !== null ? title : ''}
              {destination_credit === '0' &&
                <FormattedHTMLMessage id="app.equipment_furniture_parts" description="Items buy info"/>
              }
              {destination_credit === '1' &&
                <FormattedHTMLMessage id="app.app.inputs_materials" description="Items buy info"/>
              }
              <div className="show-desktop">
                <Whatsapp phone={this.context.intl.formatMessage({
                              id:"app.step_sms_whatsapp_number", defaultMessage: "542612554220"})}
                          text={this.context.intl.formatMessage({
                              id:"app.step_sms_whatsapp_text", defaultMessage: "Tengo+una+consulta"})}
                          value={this.context.intl.formatMessage({
                              id:"app.step_sms_whatsapp_label", defaultMessage: "261-2554-220"})}
                          gaEvent="true" gaCategory="CallToAction" gaAction="WhatsApp Tapping"/>
                <FormattedHTMLMessage id="app.whatsapp_timetable" description="Wp timetable"/>
                <SaveStepButton/>
              </div>
          </div>
          <div style={{height:'30px'}}></div>
          <div className="pd-content-right col-sm-12 col-md-7 col-lg-7">
            <form onSubmit={handleSubmit}>
              {this.props.isLoading &&  <CustomSpinner message='Estamos analizando tu solicitud. Por favor esperá...' /> }
              {destination_credit === '0' &&
                <FieldArray name="items_buy" component={this.renderitemsBuyWithFinanced} />
              }
              {destination_credit === '1' &&
                <FieldArray name="items_buy" component={this.renderitemsBuy} />
              }
              <div className="row">
                <div className="col-sm-12 col-md-12 col-lg-12 text-center">
                    <button type="submit" className="btn btn-warning btn-lg pd-button pd-form" disabled={submitting}>Continuar</button>
                </div>
              </div>
            </form>
            <div className="show-mobile">
              <Whatsapp phone={this.context.intl.formatMessage({
                            id:"app.step_sms_whatsapp_number", defaultMessage: "542612554220"})}
                        text={this.context.intl.formatMessage({
                            id:"app.step_sms_whatsapp_text", defaultMessage: "Tengo+una+consulta"})}
                        value={this.context.intl.formatMessage({
                            id:"app.step_sms_whatsapp_label", defaultMessage: "261-2554-220"})}
                        gaEvent="true" gaCategory="CallToAction" gaAction="WhatsApp Tapping"/>
              <FormattedHTMLMessage id="app.whatsapp_timetable" description="Wp timetable"/>
              <SaveStepButton/>
            </div>
          </div>
        </div>
      </Section>
    );
  }
}

ItemsBuyForm.contextTypes = {
        intl: React.PropTypes.object.isRequired
    }

ItemsBuyForm = TopScrolleable(ItemsBuyForm);

ItemsBuyForm = reduxForm({
  form: 'fieldArrays', // a unique identifier for this form
  validate,
  initialValues: {
    "items_buy": [
              {}
               ]
                 }
})(ItemsBuyForm);

ItemsBuyForm = withAuthControl(ItemsBuyForm);

export default ItemsBuyForm;


/** WEBPACK FOOTER **
 ** ./src/components/ItemsBuyForm.js
 **/